(function() {
  const carousel = document.getElementById('product-carousel');
  const placeholder = document.getElementById('carousel-placeholder');
  const track = document.getElementById('carousel-track');
  const prevBtn = document.querySelector('.product-carousel .carousel-nav.prev');
  const nextBtn = document.querySelector('.product-carousel .carousel-nav.next');

  if (!track || !carousel || !placeholder) return;

  // Sticky scroll functionality
  let carouselOriginalTop = 0;
  let carouselHeight = 0;
  let stickyThreshold = 50; // Distance from top when carousel should stick

  function updateCarouselPosition() {
    // Get the placeholder's position if carousel is sticky, otherwise get carousel's position
    if (carousel.classList.contains('sticky')) {
      carouselOriginalTop = placeholder.offsetTop;
    } else {
      carouselOriginalTop = carousel.offsetTop;
    }
    carouselHeight = carousel.offsetHeight;
  }

  function initStickyScroll() {
    // Remove sticky class temporarily to get accurate measurements
    const wasSticky = carousel.classList.contains('sticky');
    if (wasSticky) {
      carousel.classList.remove('sticky');
      placeholder.classList.remove('active');
    }

    // Get accurate position
    carouselOriginalTop = carousel.offsetTop;
    carouselHeight = carousel.offsetHeight;
    placeholder.style.height = carouselHeight + 'px';

    // Restore sticky state if needed
    if (wasSticky) {
      carousel.classList.add('sticky');
      placeholder.classList.add('active');
    }
  }

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate the trigger point (when carousel should become sticky)
    const triggerPoint = carouselOriginalTop - stickyThreshold;

    if (scrollTop >= triggerPoint) {
      if (!carousel.classList.contains('sticky')) {
        carousel.classList.add('sticky');
        placeholder.classList.add('active');
        // Update position after becoming sticky
        updateCarouselPosition();
      }
    } else {
      if (carousel.classList.contains('sticky')) {
        carousel.classList.remove('sticky');
        placeholder.classList.remove('active');
        // Recalculate position after unsticking
        setTimeout(() => {
          carouselOriginalTop = carousel.offsetTop;
        }, 50);
      }
    }
  }

  // Initialize immediately and on load
  initStickyScroll();
  window.addEventListener('load', () => {
    setTimeout(initStickyScroll, 100); // Delay to ensure all content is loaded
  });

  // Handle scroll
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Recalculate on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initStickyScroll();
    }, 100);
  });

  // Carousel navigation
  const cardWidth = track.querySelector('.product-card')?.offsetWidth || 0;
  const gap = parseInt(carousel.dataset.productGap) || 0;
  const scrollAmount = cardWidth + gap;
  const scrollCount = parseInt(carousel.dataset.scrollCount) || 2;

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({
        left: -scrollAmount * scrollCount,
        behavior: 'smooth'
      });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({
        left: scrollAmount * scrollCount,
        behavior: 'smooth'
      });
    });
  }

  // Autoplay
  if (carousel.dataset.enableAutoplay === 'true') {
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5;

    let autoplayInterval = setInterval(() => {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    }, autoplaySpeed * 1000);

    track.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
    track.addEventListener('mouseleave', () => {
      autoplayInterval = setInterval(() => {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      }, autoplaySpeed * 1000);
    });
  }
})();
